export const wordLimit = (str = '', wordLimit = 24) => {
  const words = str.split(' ');
  if (words.length <= wordLimit) return str;
  return `${words.slice(0, wordLimit).join(' ')}…`;
}

export const ucFirst = (str = '') =>
  `${str.charAt(0).toUpperCase()}${str.slice(1)}`;
